__webpack_require__.p = "/blog-react/";